import MomentUtils from '@date-io/moment';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import Pusher from 'pusher-js';
import React from 'react';
import ReactDOM from 'react-dom';
// Pusher Client
// We use this to bind pusher to component lifecycles
import { setPusherClient } from 'react-pusher';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'store';
import lightTheme from 'styles/light';
import App from './App';
import './fonts/Basier Circle/Web/BasierCircle-Medium.ttf';
import './fonts/Basier Circle/Web/BasierCircle-Regular.ttf';
import './fonts/Basier Circle/Web/BasierCircle-SemiBold.ttf';
import './fonts/Geomanist/Web/Geomanist-Medium.ttf';
import './index.scss';

const pusherClient = new Pusher('b874616b045f6f96230c', {
  cluster: 'eu',
  encrypted: true,
});
setPusherClient(pusherClient);
// ---

async function registerSW() {
  if ('serviceWorker' in navigator) {
    try {
      await navigator.serviceWorker.register('/sw.js');
    } catch (e) {}
  }
}

window.intercomSettings = {
  app_id: process.env.REACT_APP_INTERCOM_APP_ID,
};

(function () {
  var w = window;
  var ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    var d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    var l = function () {
      var s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src =
        'https://widget.intercom.io/widget/' +
        process.env.REACT_APP_INTERCOM_APP_ID;
      var x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    };
    if (document.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
})();

window.addEventListener('load', e => {
  registerSW();
});

ReactDOM.render(
  <React.Fragment>
    <CssBaseline />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MuiThemeProvider theme={lightTheme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <App />
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </PersistGate>
    </Provider>
  </React.Fragment>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.jsx